import { render, staticRenderFns } from "./EditSpeakerSocials.vue?vue&type=template&id=0d03d27d"
import script from "./EditSpeakerSocials.vue?vue&type=script&lang=js"
export * from "./EditSpeakerSocials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports